<template>
  <div class="video-box" :style="{ width: width, height: height }">
    <video class="video-js vjs-big-play-centered" ref="videoPlayer" v-if="videoUrl"></video>
    <img :src="coverUrl" class="video-cover" alt="" v-else>
  </div>
</template>

<script setup>
import videojs from "video.js";
import video_zhCN from "video.js/dist/lang/zh-CN.json";
import "video.js/dist/video-js.css";
import { defineProps, ref, watch, onMounted, onUnmounted } from 'vue'

videojs.addLanguage("zh-CN", video_zhCN);

const props = defineProps({
  videoUrl: String,
  coverUrl: String,
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '100%'
  },
  isAutoPlay: {
    type: Boolean,
    default: false
  }
})

// 播放器实例
let player = ref(null);
// vidoe dom
let videoPlayer = ref(null);
// 播放器参数配置
const options = {
  controls: true, //是否显示播放器控件
  autoplay: props.isAutoPlay, //是否自动播放
  poster: props.coverUrl,
  preload: "auto",
  aspectRatio: '16:9',
  fluid: false, // 自适应宽高
  controlBar: {
    children: [
      {
        name: "playToggle",
      },
      {
        name: "currentTimeDisplay",
      },
      {
        name: "progressControl",
      },
      {
        name: "durationDisplay",
      },
      {
        name: "volumePanel",
        inline: false,
      },
      {
        name: "FullscreenToggle",
      },
    ],
  },
};

// 初始化视频播放器
const initVideoPlayer = (url) => {
  
  player.value = videojs(
    unref(videoPlayer),
    options,
    onPlayerReady
  );

  function onPlayerReady() {
    console.log("onPlayerReady", this);
    this.src(url);
    // 监听视频播放
    this.on('play', function () {
      console.log('play')
    })
    // 监听视频暂停
    this.on('pause', function () {
      console.log('pause')
    })
  }
};

onMounted(() => {
  props.videoUrl && initVideoPlayer(props.videoUrl);
});

onUnmounted(() => {
  player.value.dispose()
})
</script>

<style lang="scss" scoped>
.video-box {
  width: 100%;
  margin: auto;
  .video-cover {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  :deep(.video-js) {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    /* 视频占满容器高度 */
    &.vjs-paused .vjs-big-play-button {
      /* 视频暂停时显示播放按钮 */
      display: block;
    }

    .vjs-tech {
      border-radius: 16px;
    }

    .vjs-poster {
      border-radius: 16px;
      background-size: cover;
    }

    .vjs-control-bar {
      border-radius: 0 0 16px 16px;
    }

    &.vjs-error .vjs-big-play-button {
      /* 视频加载出错时隐藏播放按钮 */
      display: none;
    }

    .vjs-current-time,
    .vjs-no-flex .vjs-current-time {
      display: block;
    }

    .vjs-duration,
    .vjs-no-flex .vjs-duration {
      display: block;
    }

    .vjs-slider-vertical .vjs-volume-level:before {
      left: -0.5em;
    }

    .vjs-big-play-button {
      /* 中间大的播放按钮 */
      font-size: 2.5em;
      line-height: 2.3em;
      height: 2.5em;
      width: 2.5em;
      border-radius: 2.5em;
      background-color: rgba(115, 133, 159, 0.5);
      border-width: 0.12em;
      margin-top: -1.25em;
      margin-left: -1.75em;
    }

    .vjs-time-tooltip {
      word-break: normal;
    }
  }
}
</style>